import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpEventType,
    HttpErrorResponse,
    HttpInterceptor
} from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService) { }
    intercept(request: HttpRequest<Record<string, unknown>>, next: HttpHandler): Observable<HttpEvent<HttpEventType>> {
        request = request.clone({
            setHeaders: {
                'x-session-token': `${this.auth.apiToken}`
            }
        });
        return next.handle(request).pipe(tap(() => {
            //  debugger;
        }, (err: HttpErrorResponse) => {
            if (err instanceof HttpErrorResponse) {
                // console.log(err);
                if (err.status === 419 || err.status===401) {
                    this.auth.logout();
                }
            }
        }));
    }
}
